import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { InstagramFeedPost, InstagramFeedPostSortField } from '@anytag/graphql';

export const useInfluencerInstagramPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InstagramFeedPost>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Post'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.thumbnail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'impressions',
      header: t<string>('HeaderColumn.Impression'),
      meta: { align: 'right', help: t<string>('Tooltip.ImpsHelp'), sortField: InstagramFeedPostSortField.IMPRESSIONS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.impressions)} />
    },
    {
      accessorKey: 'reach',
      header: t<string>('HeaderColumn.Reach'),
      meta: { align: 'right', help: t<string>('Tooltip.ReachPostHelp'), sortField: InstagramFeedPostSortField.REACH },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.reach)} />
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: { align: 'right', help: t<string>('Tooltip.LikeHelp'), sortField: InstagramFeedPostSortField.LIKE },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.likes)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: { align: 'right', help: t<string>('Tooltip.CommentHelp'), sortField: InstagramFeedPostSortField.COMMENT },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'saved',
      header: t<string>('HeaderColumn.Save'),
      meta: { align: 'right', help: t<string>('Tooltip.SaveHelp'), sortField: InstagramFeedPostSortField.SAVED },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.saved)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { help: t<string>('Tooltip.PostDateHelp'), sortField: InstagramFeedPostSortField.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
